import { initiateRequest } from "../request/action";
import {
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  SEND_RESET_PASSWORD_EMAIL,
  CONFIRM_PASSWORD_RESET,
  GET_CURRENT_USER,
  CLEAR_ERROR,
  VERIFY_AUTH,
  VERIFY_AUTH_SUCCESS,
  VERIFY_AUTH_FAILURE,
  SET_LAST_IDLE,
} from "./actionType";
import { User } from "../../core/entities/user";

export const login = (email: string, password: string) => ({
  type: LOGIN,
  payload: {
    email,
    password,
  },
});

export const loginSuccess = (
  user: {
    id: string;
    token: string;
    name: string;
    email: string;
    isAdmin: boolean;
    isSuperAdmin: boolean;
  } | null
) => ({
  type: LOGIN_SUCCESS,
  payload: user,
});

export const loginFailure = (error: string) => ({
  type: LOGIN_FAILURE,
  payload: { error },
});

export const logout = () =>
  initiateRequest({
    type: LOGOUT,
  });

export const sendResetPasswordEmail = (email: string) =>
  initiateRequest({
    type: SEND_RESET_PASSWORD_EMAIL,
    payload: {
      email,
    },
  });

export const confirmPasswordReset = (code: string, newPassword: string) =>
  initiateRequest({
    type: CONFIRM_PASSWORD_RESET,
    payload: {
      code,
      newPassword,
    },
  });

export const getCurrentUser = (user: User) => ({
  type: GET_CURRENT_USER,
  payload: { user },
});

export const clearErrors = () => ({ type: CLEAR_ERROR });

export const verifyAuth = () => initiateRequest({ type: VERIFY_AUTH });

export const verifyAuthSuccess = (authenticated: boolean) => ({
  type: VERIFY_AUTH_SUCCESS,
  payload: authenticated,
});

export const verifyAuthFailure = (error: string) => ({
  type: VERIFY_AUTH_FAILURE,
  payload: { error },
});

export const setLastIdle = (time: string) => ({
  type: SET_LAST_IDLE,
  payload: { time },
});
